import { render, staticRenderFns } from "./Volunteer.vue?vue&type=template&id=bae3fa4a&scoped=true&"
import script from "./Volunteer.vue?vue&type=script&lang=js&"
export * from "./Volunteer.vue?vue&type=script&lang=js&"
import style0 from "./Volunteer.vue?vue&type=style&index=0&id=bae3fa4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae3fa4a",
  null
  
)

export default component.exports